
import Component from '../../../assets/scripts/modules/component'

class ProductFormComponent extends Component {
  init () {
    this.products = [...this.element.querySelectorAll('.product-form__product')]

    if (!this.products.length) {
      return
    }

    for (const product of this.products) {
      const contentWrapper = product.querySelector('.product-form__product-content')
      const toggleLink = product.querySelector('.link--toggle')

      if (contentWrapper && toggleLink) {
        toggleLink.addEventListener('click', event => this.toggleContentWrapper(event, contentWrapper, toggleLink))
      }
    }
  }

  toggleContentWrapper (event, contentWrapper, toggleLink) {
    event.preventDefault()

    if (toggleLink.getAttribute('aria-expanded') === 'true') {
      toggleLink.setAttribute('aria-expanded', false)
      contentWrapper.setAttribute('aria-hidden', true)
    } else {
      toggleLink.setAttribute('aria-expanded', true)
      contentWrapper.setAttribute('aria-hidden', false)
    }
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.product-form')) {
    element.instance = element.instance || new ProductFormComponent(element)
  }
})
